import { render, staticRenderFns } from "./HoldList.vue?vue&type=template&id=0c8b8590&scoped=true&"
import script from "./HoldList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HoldList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HoldList.vue?vue&type=style&index=0&id=0c8b8590&prod&scoped=true&lang=scss&"
import style1 from "./HoldList.vue?vue&type=style&index=1&id=0c8b8590&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8b8590",
  null
  
)

export default component.exports